import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Mail, ArrowLeft, CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PasswortVergessen = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.includes('@')) {
      setError(t('pw_vergessen.error.invalid_email'));
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/password-reset/request`, { email });
      setSent(true);
    } catch (_e) {
      // Auch bei Fehler: zeige Erfolg (kein Enumeration)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#fbfcfd] flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center py-12 px-4">
        <div className="w-full max-w-md bg-white border-t-4 border-[#b8893d] shadow-sm p-8" data-testid="forgot-pw-card">
          <Link to="/login" className="inline-flex items-center gap-1.5 text-xs text-[#34536b] hover:text-[#1B3A5C] mb-6">
            <ArrowLeft className="w-3 h-3" /> {t('pw_vergessen.back_to_login')}
          </Link>
          {!sent ? (
            <>
              <h1 className="font-serif text-2xl text-[#1B3A5C] mb-2">{t('pw_vergessen.title')}</h1>
              <p className="text-sm text-[#34536b] mb-6">
                {t('pw_vergessen.description')}
              </p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="block text-[10px] tracking-[0.2em] text-[#34536b] mb-1.5">{t('pw_vergessen.label.email')}</label>
                  <div className="relative">
                    <Mail className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-[#34536b]/50" />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={t('pw_vergessen.placeholder.email')}
                      required
                      autoFocus
                      data-testid="forgot-pw-email"
                      className="w-full pl-8 pr-3 py-2.5 text-sm border border-[#1B3A5C]/20 focus:outline-none focus:border-[#b8893d]"
                    />
                  </div>
                </div>
                {error && <p className="text-xs text-rose-600">{error}</p>}
                <Button type="submit" disabled={loading} data-testid="forgot-pw-submit"
                        className="w-full bg-[#1B3A5C] hover:bg-[#34536b] text-white text-xs tracking-[0.2em] py-2.5">
                  {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : t('pw_vergessen.button.send_link')}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center space-y-4" data-testid="forgot-pw-success">
              <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
              <h1 className="font-serif text-2xl text-[#1B3A5C]">{t('pw_vergessen.success.title')}</h1>
              <p className="text-sm text-[#34536b]">
                {t('pw_vergessen.success.description_1')} <strong>{t('pw_vergessen.success.validity')}</strong>{t('pw_vergessen.success.description_2')}
              </p>
              <p className="text-xs text-[#34536b]/70">
                {t('pw_vergessen.success.no_mail')}
              </p>
              <Link to="/login" className="inline-block text-xs tracking-wider text-[#b8893d] hover:underline">
                {t('pw_vergessen.success.to_login')}
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PasswortVergessen;
